import { RSAA } from 'redux-api-middleware';
import debounceAction from 'debounce-action';

import {
  NEXT_CREATE_STAGE,
  PREVIOUS_CREATE_STAGE,
  RESET_STEPS,
  SELECT_SERVICE,
  SELECT_VERSION,
  SELECT_REGION,
  ENTER_NAME,
  SELECT_FLAVOR,
  SELECT_PLAN,
  ENTER_CIDR,
  ENTER_ACL_NAME,
  SELECT_ACL_KIND,
  ADD_ACL,
  REMOVE_ACL,
  ADD_IPS_LATER,
  SELECT_SERVICE_SUBTYPE,
  SELECT_PROVIDER,
  CREATEINSTANCE_REQUESTED,
  CREATEINSTANCE_SUCCESS,
  CREATEINSTANCE_FAILURE,
  RESET_CREATEINSTANCE_ERROR_STATE,
  GETIP_REQUESTED,
  GETIP_SUCCESS,
  GETIP_FAILURE,
  GETIP_CLEAR,
  GET_PRICE_REQUESTED,
  GET_PRICE_SUCCESS,
  GET_PRICE_FAILURE,
  SELECT_ADDON,
  DESELECT_ADDON,
} from '../actions';

const goToNextStageActionSet = (currentStep) => ({
  type: NEXT_CREATE_STAGE,
  payload: currentStep + 1,
});

export const goToNextStage = (event, step) => (dispatch) => dispatch(goToNextStageActionSet(step));

const goToPreviousStageActionSet = (currentStep) => ({
  type: PREVIOUS_CREATE_STAGE,
  payload: currentStep - 1,
});

export const goToPreviousStage = (event, step) => (dispatch) =>
  dispatch(goToPreviousStageActionSet(step));

const resetStepsActionSet = () => ({
  type: RESET_STEPS,
  payload: 0,
});

export const resetSteps = () => (dispatch) => dispatch(resetStepsActionSet());

const selectServiceSet = (selectedService, defaultSubtype, defaultCloudProvider) => ({
  type: SELECT_SERVICE,
  payload: { selectedService, defaultSubtype, defaultCloudProvider },
});

export const selectService = (event, selectedService, defaultSubtype, defaultCloudProvider) => (
  dispatch,
) => dispatch(selectServiceSet(selectedService, defaultSubtype, defaultCloudProvider));

const selectVersionSet = (event) => ({
  type: SELECT_VERSION,
  payload: event.target.value,
});

export const selectVersion = (event) => (dispatch) => dispatch(selectVersionSet(event));

const selectRegionSet = (event) => ({
  type: SELECT_REGION,
  payload: event.target.value,
});

export const selectRegion = (event) => (dispatch) => dispatch(selectRegionSet(event));

const enterNameSet = (event) => ({
  type: ENTER_NAME,
  payload: event.target.value,
});

export const enterName = (event) => (dispatch) => dispatch(enterNameSet(event));

const selectFlavorSet = (value, defaultPlan) => ({
  type: SELECT_FLAVOR,
  payload: { value, defaultPlan },
});

export const selectFlavor = (value, defaultPlan) => (dispatch) =>
  dispatch(selectFlavorSet(value, defaultPlan));

export const selectPlanSet = (planIndex, plans) => {
  const MAX = plans.length - 1;
  let actualPlanIndex;
  if (planIndex < 0) {
    actualPlanIndex = 0;
  } else if (planIndex > MAX) {
    actualPlanIndex = MAX;
  } else {
    actualPlanIndex = planIndex;
  }
  return {
    type: SELECT_PLAN,
    payload: { planIndex: actualPlanIndex, plan: plans[actualPlanIndex] },
  };
};

export const selectPlan = (planIndex, plan) => (dispatch) =>
  dispatch(selectPlanSet(planIndex, plan));

const enterCidrSet = (value) => ({
  type: ENTER_CIDR,
  payload: value,
});

export const enterCidr = (event, value) => (dispatch) => dispatch(enterCidrSet(value));

const getIpSet = () => ({
  [RSAA]: {
    types: [GETIP_REQUESTED, GETIP_SUCCESS, GETIP_FAILURE],
    method: 'GET',
    endpoint: '/getip/',
  },
});

export const getIp = () => (dispatch) => dispatch(getIpSet());

const getIpClearSet = () => ({
  type: GETIP_CLEAR,
});

export const getIpClear = () => (dispatch) => dispatch(getIpClearSet());

const enterAclNameSet = (event) => ({
  type: ENTER_ACL_NAME,
  payload: event.target.value,
});

export const enterAclName = (event) => (dispatch) => dispatch(enterAclNameSet(event));

const selectAclKindSet = (kind) => ({
  type: SELECT_ACL_KIND,
  payload: kind,
});

export const selectAclKind = (event, kind) => (dispatch) => dispatch(selectAclKindSet(kind));

const addAclSet = (value) => ({
  type: ADD_ACL,
  payload: value,
});

export const addAcl = (event, value) => (dispatch) => dispatch(addAclSet(value));

const removeAclSet = (value) => ({
  type: REMOVE_ACL,
  payload: value,
});

export const removeAcl = (event, value) => (dispatch) => dispatch(removeAclSet(value));

const checkAddIpsLaterSet = () => ({
  type: ADD_IPS_LATER,
});

export const checkAddIpsLater = () => (dispatch) => dispatch(checkAddIpsLaterSet());

const selectServiceSubtypeSet = (serviceSubtype) => ({
  type: SELECT_SERVICE_SUBTYPE,
  payload: serviceSubtype,
});

export const selectServiceSubtype = (event, serviceSubtype) => (dispatch) =>
  dispatch(selectServiceSubtypeSet(serviceSubtype));

const selectProviderSet = (provider) => ({
  type: SELECT_PROVIDER,
  payload: provider,
});

export const selectProvider = (event, provider) => (dispatch) =>
  dispatch(selectProviderSet(provider));

const createInstanceSet = (data) => ({
  [RSAA]: {
    types: [
      {
        type: CREATEINSTANCE_REQUESTED,
        meta: {
          analytics: {
            eventPayload: {
              properties: {
                instance_name: data.name,
                service: data.service,
                plan: data.plan,
                version: data.version,
                region: data.region,
                provider: data.provider,
                service_subtype: data.serviceSubtype,
                features: data.features,
                num_acls: data.acls.length,
              },
            },
          },
        },
      },
      {
        type: CREATEINSTANCE_SUCCESS,
        meta: {
          analytics: true,
          service: data.service,
        },
      },
      {
        type: CREATEINSTANCE_FAILURE,
        meta: {
          analytics: {
            eventPayload: {
              properties: {
                instance_name: data.name,
                service: data.service,
                plan: data.plan,
                version: data.version,
                region: data.region,
                provider: data.provider,
                service_subtype: data.serviceSubtype,
                features: data.features,
                num_acls: data.acls.length,
              },
            },
          },
        },
      },
    ],
    method: 'POST',
    endpoint: `/instances/${data.service.toLowerCase()}/`,
    body: JSON.stringify(data),
  },
});

export const createInstance = (data, cb) => (dispatch) =>
  dispatch(createInstanceSet(data)).then((response) => {
    if (response.type === CREATEINSTANCE_SUCCESS) {
      cb();
    }
  });

const resetCreateInstanceErrorStateActionSet = () => ({
  type: RESET_CREATEINSTANCE_ERROR_STATE,
  payload: null,
});

export const resetCreateInstanceErrorState = () => (dispatch) =>
  dispatch(resetCreateInstanceErrorStateActionSet());

const getPriceActionSet = (regionId, planIndex, plans, addons) => {
  const MAX = plans.length - 1;
  let actualPlanIndex;
  if (planIndex < 0) {
    actualPlanIndex = 0;
  } else if (planIndex > MAX) {
    actualPlanIndex = MAX;
  } else {
    actualPlanIndex = planIndex;
  }
  const planId = plans[actualPlanIndex].id;

  const addonQuery = addons.map((addon) => `&addon=${addon.id}_value_${addon.value}`).join('');

  return {
    [RSAA]: {
      types: [GET_PRICE_REQUESTED, GET_PRICE_SUCCESS, GET_PRICE_FAILURE],
      method: 'GET',
      endpoint: `/pricing/?region=${regionId}&plan=${planId}${addonQuery}`,
    },
  };
};

export const getPrice = (regionId, planIndex, plans, addons = []) => (dispatch) =>
  dispatch(getPriceActionSet(regionId, planIndex, plans, addons));

export const getPriceDebounced = debounceAction(getPrice, 250);

const selectAddonSet = (id, name, value) => ({
  type: SELECT_ADDON,
  payload: { id, name, value },
});

export const selectAddon = (id, name, value) => (dispatch) =>
  dispatch(selectAddonSet(id, name, value));

const deselectAddonSet = (addonId) => ({
  type: DESELECT_ADDON,
  payload: addonId,
});

export const deselectAddon = (addonId) => (dispatch) => dispatch(deselectAddonSet(addonId));
